import React from 'react';
import { Navigate } from 'react-router-dom';
import useGetRole from "../hooks/useGetRole";

const PrivateCompanyRoute = ({ children }) => {
  const roleSelected = useGetRole.getRole();
  const isNotPatient = roleSelected !== 'paciente';

  // Show the component only when the user role is NOT patient
  // Otherwise, redirect the user to /inicio page
  if (!isNotPatient) {
    return <Navigate to="/inicio" replace />;
  }

  return children;
};

export default PrivateCompanyRoute;